import { useInfiniteQuery } from "react-query";
import {
    GetListRoomExclusiveResponse,
    ParamsGetRoomCoWorkExclusive,
} from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetRoomCoWorkExclusive) => {
    const apiGetListRoomExclusive = queryString.stringifyUrl({
        url: "api/mruangans-khusus",
        query: {
            page: params.page,
            size: params.size,
            search: params.search,
            status: params.status,
        },
    });
    const { data } = await axios.get<GetListRoomExclusiveResponse>(apiGetListRoomExclusive);
    return {
        results: data.data,
        nextPage: params.page + 1,
        totalPages: Math.ceil(data.data.totalElements / data.data.size),
    };
};

export default function useRoomCoWorkExclusive(params: ParamsGetRoomCoWorkExclusive, options?: { enabled?: boolean }) {
    return useInfiniteQuery(
        ["list-room-khusus", params],
        ({ pageParam = 1 }) => {
            return handleRequest({ ...params, page: pageParam });
        },
        {
            getNextPageParam: (lastPage, pages) => {
                if (lastPage.nextPage <= lastPage.totalPages)
                    return lastPage.nextPage;
                return undefined;
            },
            enabled: options?.enabled ?? true,
        },
    );
}